module.exports = __webpack_public_path__ + "static/img/creature-peeking.6d9258a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/creature-peeking.jpg
// module id = 326
// module chunks = 0